module.exports = __webpack_public_path__ + "static/media/gulabjamun.e913fbef.jpg";